import { useNavigate as _useNavigate } from 'react-router-dom'
import { useContext, useEffect, useRef } from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import * as _ from 'underscore'
import './index.less'
import * as d3 from 'd3'
import { ToolProps } from '@/components/SegmentHelpers/Interfaces'
import SegmentContext from '@/components/SegmentHelpers/hooks/createContext'
import { SEGTYPE_HOVER } from '@/components/SegmentHelpers/config'
const Tool = ({
  handleMouseDown,
  handleMouseMove,
  handleMouseUp,
  handleClick,
  svgRef,
  isDragging
}: ToolProps) => {
  const {
    clicks: [, setClicks],
    image: [image],
    maskImg: [maskImg, setMaskImg],
    clipData: [, setClipData],
    segmentType: [segmentType, _setSegmentType],
    isReset: [isReset, setIsReset],
    canvasWidth: [_canvasWidth, setCanvasWidth],
    canvasHeight: [_canvasHeight, setCanvasHeight],
    isEverythingRemoved: [isEverythingRemoved],
    currentImageIndex: [_currentImageIndex, _setCurrentImageIndex],
    isLoading: [isLoading],
    isSaving: [isSaving]
  } = useContext(SegmentContext)!
  const imgRef = useRef<HTMLImageElement>(null)

  useEffect(() => {
    if (isReset) {
      setClicks([])
      setMaskImg(null)
      setClipData(null)
      setIsReset(false)
      const svg = d3.select(svgRef.current)
      return () => {
        svg.selectAll('*').remove()
      }
    }
  }, [isReset])
  useEffect(() => {
    if (imgRef.current) {
      const width = imgRef.current.width
      const height = imgRef.current.height
      svgRef.current.style.width = width
      svgRef.current.style.height = height
      setCanvasWidth(width)
      setCanvasHeight(height)
    }
  }, [imgRef.current?.width, imgRef.current?.height])
  const handleDragStart = (e: React.DragEvent<HTMLImageElement>) => {
    e.preventDefault()
  }
  return (
    <>
      {isLoading || isSaving ? (
        <LoadingOutlined style={{ fontSize: '50px' }} />
      ) : (
        <>
          {image && (
            <img
              onClick={isDragging ? undefined : handleClick}
              placeholder={'loading...'}
              onMouseDown={handleMouseDown}
              onMouseMove={handleMouseMove}
              onMouseUp={handleMouseUp}
              onDragStart={handleDragStart}
              onMouseOut={() =>
                _.defer(() => {
                  if (segmentType == SEGTYPE_HOVER) {
                    // dispatch(setMaskImg(null))
                    setMaskImg(null)
                  }
                })
              }
              ref={imgRef}
              onTouchStart={handleMouseMove}
              src={image.src}
              className='segment-pic'
              style={{ pointerEvents: isEverythingRemoved || isLoading ? 'none' : 'auto' }}
            />
          )}
          {maskImg && <img src={maskImg.src} className='segment-mask' />}
          {image && (
            <svg
              ref={svgRef}
              className='segment-pic'
              style={{ pointerEvents: isEverythingRemoved ? 'auto' : 'none' }}
            />
          )}
        </>
      )}
    </>
  )
}
export default Tool
